import useSydExpandableInformationDetails from 'components/Shared/SydExpandableInformationDetails/useSydExpandableInformationDetails'
import './styles.scss'

interface ISydExpandableInformationDetailsProps {
  content: JSX.Element
  title: string
  className?: string
  titleIcon?: string
  closeToggleElement?: string | JSX.Element
  openToggleElement?: string | JSX.Element
}

const SydExpandableInformationDetails = ({
  className,
  content,
  title,
  titleIcon,
  openToggleElement = 'Ocultar detalles',
  closeToggleElement = 'Mostrar detalles',
}: ISydExpandableInformationDetailsProps) => {
  const { contentRef, detailsRef, isExpanding, open, summaryRef, toggleOpen } =
    useSydExpandableInformationDetails()

  return (
    <details
      open={open}
      ref={detailsRef}
      className={`syd-expandable-information-details-component ${className ?? ''}`}
      onClick={e => e.preventDefault()}>
      <summary ref={summaryRef}>
        <div className="title">
          {titleIcon && <img src={titleIcon} alt="icono"></img>}
          <span>{title}</span>
        </div>
        <div className="action-row">
          <button
            type="button"
            className="expand-button"
            aria-expanded="false"
            aria-controls="expandable-content"
            onClick={toggleOpen}>
            {open && !isExpanding ? openToggleElement : closeToggleElement}
          </button>
        </div>
      </summary>
      <div ref={contentRef} className={`content`}>
        {content}
      </div>
    </details>
  )
}

export default SydExpandableInformationDetails
